export enum EventLogsEnum {
    APP_ING_CHANGES = 'APP_ING_CHANGES',
    APP_ING_REMOVED = 'APP_ING_REMOVED',
    APP_ING_CREATION = 'APP_ING_CREATION',
    APP_REMOVE_SUB_STEP = 'APP_REMOVE_SUB_STEP',
    APP_ADD_SUB_STEP = 'APP_ADD_SUB_STEP',
    APP_RECIPE_SUB_STEP_EDIT = 'APP_RECIPE_SUB_STEP_EDIT',
    APP_PRESET_APPLIED = 'APP_PRESET_APPLIED',
    APP_MANUAL_INSTRUCTION = 'APP_MANUAL_INSTRUCTION',
    APP_PRESET_EDIT = 'APP_PRESET_EDIT',
    APP_SUBSTEP_SAVED = 'APP_SUBSTEP_SAVED',
    APP_RECIPE_VIEW = 'APP_RECIPE_VIEW',
    APP_RECIPE_CREATION_INITIALISED = 'APP_RECIPE_CREATION_INITIALISED',
    APP_RECIPE_NAME_EDIT = 'APP_RECIPE_NAME_EDIT',
    APP_RECIPE_NAME_EDIT_SAVED = 'APP_RECIPE_NAME_EDIT_SAVED',
    APP_RECIPE_DELETE_CONFIRM = 'APP_RECIPE_DELETE_CONFIRM',
    APP_RECIPE_DELETION_TRIGGERED = 'APP_RECIPE_DELETION_TRIGGERED',
    APP_HOMEPAGE_INITIALIZED = 'APP_HOMEPAGE_INITIALIZED',
    APP_RECIPE_OPENED = 'APP_RECIPE_OPENED',
    APP_LISTVIEW_OPENED = 'APP_LISTVIEW_OPENED',
    APP_BANNER_OPENED = 'APP_BANNER_OPENED',
    APP_GROUP_OPENED = 'APP_GROUP_OPENED',
    APP_BACK_PRESSED = 'APP_BACK_PRESSED',
    APP_RECIPE_CREATE_CHEF_GPT = 'APP_RECIPE_CREATE_CHEF_GPT',
    APP_RECIPE_CREATE_DUPLICATE = 'APP_RECIPE_CREATE_DUPLICATE',
    APP_RECIPE_CREATE_TEMPLATE = 'APP_RECIPE_CREATE_TEMPLATE',
    APP_FAVOURITES_OPENED = 'APP_FAVOURITES_OPENED',
    APP_OPEN_ON_DEVICE = 'APP_OPEN_ON_DEVICE',
    APP_CANCEL_OPEN_ON_DEVICE = 'APP_CANCEL_OPEN_ON_DEVICE',
    APP_ERROR_OPEN_ON_DEVICE = 'APP_ERROR_OPEN_ON_DEVICE',
    APP_COOKING_HISTORY = "APP_COOKING_HISTORY",
    APP_HISTORY_PAGE_OPENED = "APP_HISTORY_PAGE_OPENED",
    APP_STAR_RATING = "APP_STAR_RATING",
    APP_SHARE_FEEDBACK_OPENED = "APP_SHARE_FEEDBACK_OPENED",
    APP_RATING_SUBMIT_FEEDBACK_PAGE = "APP_RATING_SUBMIT_FEEDBACK_PAGE",
    APP_RATING_SKIPNOW_FEEDBACK_PAGE = "APP_RATING_SKIPNOW_FEEDBACK_PAGE",
    APP_ADD_FAVORITES_HISTORY_PAGE = "APP_ADD_FAVORITES_HISTORY_PAGE",
    APP_VIEW_FEEDBACK_OPENED = "APP_VIEW_FEEDBACK_OPENED",
    APP_EDIT_FEEDBACK = "APP_EDIT_FEEDBACK",
    APP_RECIPE_CARD_OPENED = "APP_RECIPE_CARD_OPENED",
    APP_VIEW_REVIEWS = 'APP_VIEW_REVIEWS',
    APP_UN_FAVORITE_HISTORY_PAGE = 'APP_UN_FAVORITE_HISTORY_PAGE',
    GENERATE_MEAL_PLAN_OPENED = "GENERATE_MEAL_PLAN_OPENED",
    GENERATE_MEAL_PLAN = "GENERATE_MEAL_PLAN",
    ADD_TO_MEAL_PLAN = 'ADD_TO_MEAL_PLAN',
    ADDED_PLAN_TO_MEAL_PLAN = "ADDED_PLAN_TO_MEAL_PLAN",
    COPY_INGREDIENTS = 'COPY_INGREDIENTS',
    REMOVED_FROM_GROCERY_LIST = 'REMOVED_FROM_GROCERY_LIST',
    VIEW_GROCERY_LIST='VIEW_GROCERY_LIST',
}